import React from 'react';
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import { FormTextInputProps } from './FormInputProps';
import { styled } from '@mui/material';

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    display: 'none',
  },
  '& input[type=number]': {
    MozAppearance: 'textfield',
  },
}));

const numberFormat = new Intl.NumberFormat();

const _showArrows = (textFieldProps: any) => {
  if (textFieldProps && textFieldProps.showArrows === false) return false;
  return true;
};

/**
 * Form input component that only accepts integer values (no decimals allowed).
 * Silently blocks decimal input.
 */
export const FormInputInteger = ({ name, control, label, disabled, readOnly, helperText, textFieldProps }: FormTextInputProps) => {
  const UsedTextField = _showArrows(textFieldProps) ? TextField : StyledTextField;
  
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <UsedTextField
          helperText={error ? error.message : helperText ? helperText : undefined}
          error={!!error}
          onKeyDown={event => {
            if (['.', ',', '-', '+', 'e', 'E'].includes(event.key)) {
              event.preventDefault();
            }
          }}
          onChange={event => {
            const { value } = event.target;
            
            if (value.includes('.') || value.includes(',')) {
              return;
            }
            
            if (value.length > 0) {
              const intValue = parseInt(value.toString().replace(/[^\d]/g, ''));
              if (isNaN(intValue)) onChange(null);
              else onChange(intValue);
            } else {
              onChange(null);
            }
          }}
          value={value !== null && value !== undefined ? value.toString() : ''}
          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
          fullWidth
          InputLabelProps={{
            ...(disabled ? { shrink: true } : {}),
            ...(textFieldProps && textFieldProps.InputLabelProps ? textFieldProps.InputLabelProps : {}),
          }}
          disabled={disabled || readOnly}
          label={label}
          {...textFieldProps}
        />
      )}
    />
  );
};